import React, { Component } from "react";
import { string, object, bool, func, number } from 'prop-types';
import Header from "Orgs/Header";
import FooterAccountsPage from "Orgs/FooterAccountsPage";
import TermsOfUseFooter from "Orgs/TermsOfUseFooter";
import AccountsList from "./children/AccountsList";
import SupportInfo from "Molecules/SupportInfo";
import PageHeader from "Molecules/PageHeader";
import PayModalVeil from "Atoms/PayModalVeil";
import PayModalTemplate from "Templates/PayModalTemplate";
import md5 from "md5";
import axios from "axios";
import moment from "moment";

import  { emailReceipt } from "../../../../utils/emailReceipt";
import TransactionLoader from "./transactionLoader/TransactionLoader";
import Transaction from "./transaction/Transaction";
import './AccountsPage.css';
import { MatchAccountMoreThanTwenty, NoMatchLessThanTwenty, NoMatchMoreThanTwenty } from './PaymentMessages';



let ALACRITI_URL,ALACRITI_KEY,CONFIRMATION_URL,ALACRITI_VALUE;
if(sessionStorage.getItem('app_info')){
	ALACRITI_URL=JSON.parse(sessionStorage.getItem('app_info')).ALACRITI_URL;
	ALACRITI_KEY=JSON.parse(sessionStorage.getItem('app_info')).ALACRITI_KEY;
	CONFIRMATION_URL=JSON.parse(sessionStorage.getItem('app_info')).CONFIRMATION_URL;
	ALACRITI_VALUE=JSON.parse(sessionStorage.getItem('app_info')).ALACRITI_VALUE;
}

export default class AccountsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			billingAccountNumber: this.props.match.params.billing,
            zipCode: this.props.match.params.zipCode,
			showPay: false,
			messageInfoComp: <div />,
			removeAccountListing: false,
			supportInfo:false,
			successResponse:{
				currAccount:"",
				accounts:{},
				totalAmount:"",
				selectedPayMethod:[],
				account_number:"",
				date:"",
				time:"",
				transactionID:""
			},
			errorResponse:{
				code:"",
				message:"",
			}
			
			
		}
	}
	generateRandomId = (length) => {
		let mask = '';
		mask += 'abcdefghijklmnopqrstuvwxyz';
		mask += '0123456789';
		let result = '';
		for (let i = 0; i <length; i++) {
			if(i===8 || i===13 || i===18 || i===23)	result+='-';
			else result += mask[Math.floor(Math.random() * mask.length)];
		}
		return result;
	}
	todayDateFunc = (responseDate) => {
        let myDate = new Date(responseDate);
		const monthName=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        return monthName[myDate.getMonth()]+" "+myDate.getDate()+", "+myDate.getFullYear();
    }
	
	checkoutFunc = (event) => {
		const billing_account_numbers=Object.keys(this.props.accounts);
		const updatedAccountNumbers=billing_account_numbers.filter(element=>{
			const accountValues=this.props.accounts[element];
			const accKeys=Object.keys(accountValues)
			let amountVal=+accountValues.minimum_due_amount;
			if(accKeys.includes("payment_amount")){
				amountVal=accountValues.payment_amount;
			}
			else if(accountValues.recurring_enabled && accountValues.past_due_amount===0){
				amountVal=0;
			}
			return amountVal>0;
		})

		const fields=updatedAccountNumbers.map((element,i) =>{
			const accountValues=this.props.accounts[element];
			const accKeys=Object.keys(accountValues)
			let amountVal=accountValues.minimum_due_amount;
			if(accKeys.includes("payment_amount")){
				amountVal=accountValues.payment_amount;
			}
			else if(accountValues.recurring_enabled && accountValues.past_due_amount===0){
				amountVal=0;
			}
			const index=""+(i+1);
			const key="cdf"+("0".repeat(3-index.length))+index;

			const value=`billing=${accountValues.account_number},amt=${amountVal}`;
			const obj={
				key:key,
				value:value
			}
			return obj;
		});

		const payload = {
			customerAccountreference: event.detail.customer_account_reference,
			amount:""+this.props.total_amount,
			token: event.detail.token,
			digiSign: event.detail.digiSign,
			custom_fields:fields,
			
			
			
		  }
		
		this.showLoadingHandler(true,false,{},false);

		axios({
			method: 'post',
			url: CONFIRMATION_URL,
			data: JSON.stringify(payload),
			headers: {
				'clientId':ALACRITI_VALUE,
				'Content-Type': 'application/json',
				
				'gi-trace-id':this.generateRandomId(36)
			 } 
		  })
		  .then((res) => {
			
			if("confirmationNumber" in res.data){
				const emailReceiptPayload={
					payerEmail:res.data.payer.email,
					accType:res.data.fundingAccount.accountType,
					paymentDate:this.todayDateFunc(res.data.paymentDate),
					totalAmount:res.data.amount,
					confirmationNumber:res.data.confirmationNumber,
					accountNumber:res.data.fundingAccount.accountNumber,
					customerID:res.data.payer.customerReference,
					selectedPayMethod:res.data.paymentMethod,
					accounts:this.props.accounts
				};
				
				emailReceipt(emailReceiptPayload);
			}
			
			this.showLoadingHandler(false,true,res.data,("confirmationNumber" in res.data));
			
		  })
		  .catch(err => {
			console.log(err);
			const errorMsg="It appears the issue is on our end. If you recently attempted to make a payment and have not received your confirmation number, please do not attempt another payment. Please call our customer help line 1-888-978-5371. Our team is available Mon-Fri 8 am to 8:30 pm ET. We know your time is valuable, and we apologize for the inconvenience.";
			const res={errorList:[{code:"Something's amiss",message:errorMsg}]}
			this.showLoadingHandler(false,true,res,false);
			
		  });
	}


	componentWillMount(){

        window.addEventListener('checkout-event',(event)=>this.checkoutFunc(event));
	}
	
	
	
	componentDidMount(){
		try{
			const title=document.getElementsByTagName('title')[0];
			title.textContent="Bill Pay/Payment Gateway";
		
			let currentAccountNumber = this.props.currentAccount.account_number
			if(currentAccountNumber){
				let customerNumber = currentAccountNumber.substring(0,10)
				let customerNumberHash = md5(customerNumber)
				global.digitalData.user.customerID = customerNumberHash;
				global.digitalData.page.error[0] = "";
			}
			
			
			this.handleRenderMobileViewToggle();
			global.digitalData.page.pageInfo.pageName = "Accounts Page";
			const tagName = 'script', script = document.createElement(tagName);
			script.src = ALACRITI_URL;
			script.id="orbipay-checkout-script";
			script.setAttribute("data-prevent_posting" , "true");
			script.setAttribute("data-api_event" , "create_payment");
			

			
			document.head.appendChild(script);
			window.addEventListener("resize", () => {
				if (window.innerWidth < 760) {
					this.closeBox();
				}
			});
		} catch (err){}
	}


	componentWillReceiveProps(){

		window.addEventListener("resize", this.handleRenderMobileViewToggle);
	}
	paymentConfirmation=()=>{
		window.onbeforeunload=null;
		window.location.reload(false);

	}
	handleRenderMobileViewToggle = () => {
		if (window.innerWidth < 760) {
			this.setState({
				mobileViewToggle: true
			}, () => {
				this.checkAccountCount();
			})
		} else {
			this.setState({
				mobileViewToggle: false
			}, () => {
				this.checkAccountCount();
			})
		}
	}

	checkAccountCount = () => {
		const { accountMatchBool, customerCount } = this.props;

		
		if (accountMatchBool){
			
			if(customerCount > 20){
				this.setState({
					messageInfoComp: <MatchAccountMoreThanTwenty />
				})
			}
		} else {
			

			if(customerCount < 20){
				this.setState({
					messageInfoComp: <NoMatchLessThanTwenty />
				})
			} else {
				
				this.setState({
					removeAccountListing: true,
					messageInfoComp: <NoMatchMoreThanTwenty />
				})
			}
		}
	}
	toggleSupportInfo = () =>{
		let si=!this.state.supportInfo;
		this.setState({
			...this.state,
			supportInfo:si
		});
	}
	closeBox = () =>{
		this.setState({
			...this.state,
			supportInfo:false
		});
	}
	showLoadingHandler(loadingValue,successValue,res,success){
		this.setState((prevState)=>{
			const newState={
				...prevState,
				isLoading:loadingValue,
				showSuccessfulModal:successValue,
				showOverlay:loadingValue||successValue
			}
			
			if(Object.keys(res).length!==0){
				if(success){
					let acNum=res.fundingAccount.accountNumber;
					let currentAccountNumber = this.props.currentAccount.account_number
					let customerNumber = currentAccountNumber.substring(0,10);
					let time=moment(res.timestamp,"DD-MM-YYYY HH:mm:ss A").format('h:mm A');
					time+=" ET";
					newState.successResponse={
						accounts:this.props.accounts,
						currAccount:customerNumber,
						totalAmount:res.amount,
						time:time,
						selectedPayMethod:[res.fundingAccount.accountType,res.fundingAccount.accountSubtype],
						account_number:acNum.slice(acNum.length-4),
						date:this.todayDateFunc(res.paymentDate),
						transactionID:res.confirmationNumber
					}
				}
				else{
					let errorCode=res.errorList[0].code;
					let errorMessage=res.errorList[0].message;
					newState.errorResponse={
						code:errorCode,
						message:errorMessage
					}
				}
			}

			

			return newState;
			
		});
		
		
	}

	hidePayModal = () => {
    this.props.hidePayModal();
	}
	
	

	
	handlePaymentRouting = (amt,acc) => {
		window.OrbipayCheckoutSimple.setClientKey(ALACRITI_KEY);
        window.OrbipayCheckoutSimple.setAmount(""+amt);

		const billing_account_numbers=Object.keys(acc);
        const customer_account_reference=""+billing_account_numbers[0];
        const reference_number=customer_account_reference.substring(0,10);


		window.OrbipayCheckoutSimple.setDispatchCustomEventToParent("false");
        window.OrbipayCheckoutSimple.setCustomerAccountReference(reference_number);

        window.OrbipayCheckoutSimple.setCustomerReference(reference_number); 


        window.OrbipayCheckoutSimple.setApiEvent('create_payment');
        var btn=document.getElementById("orbipay-checkout-button");
        btn.click();


        
	}

	componentWillUnmount = () => {
		window.removeEventListener("resize", this.handleRenderMobileViewToggle);
	}

	cssClasses = (showPayVeil,showModal) =>{
		let classes="";

		if(showPayVeil){
            classes = " payselect-is-open";
		} else {
            if (showModal) {
                classes = " paymodal-is-open";
            } else {
                classes = " paymodal-is-closed";
            }
        }
		return classes;
	}
	check = (conditions) => {
		return (conditions)	? true : false;
	}

	render() {
		const { accounts,
			openPayModalFunc,
			showModal,
			showPayModalFunc,
			showPayVeil,
			showPayVeilFunc,
			hidePayVeilFunc,
		 	total_amount
		 } = this.props;

		 const { messageInfoComp, removeAccountListing, mobileViewToggle } = this.state;

		
		let classes=this.cssClasses(this.props.showPayVeil,this.props.showModal);

		
		let disabledToggle = this.check(total_amount < 0.01);

		return (

			<div className={"AccountsPage " + classes}>
				<PayModalVeil />



				{this.props.showModal ? <PayModalTemplate close={this.hidePayModal}/> : <div />}
				<div className="accounts-page-contents">

				<div className="masthead">
					<Header toggleBox={this.toggleSupportInfo} closeBox={this.closeBox}/>
					{this.state.supportInfo && <div className="infoBox support-info-is-visible">
						<SupportInfo closeBox={this.toggleSupportInfo}/>
					</div>}
					<PageHeader
						title="Bill pay"
						subtitle="Choose the amount you want to pay for each account."
						/>
					</div>
					

					{ messageInfoComp }


					<div className="site-main">
					<main>
						<div className="billing-accounts-area">
							<div className="dx-col">


								{ removeAccountListing ?
									<div /> :
									<div>
										<div className="area-header">{" "}Billing Accounts{" "}</div>
									  	<div className="area-content">
											<AccountsList
												accounts={accounts}
												openPayModalFunc={openPayModalFunc}
												showModal={showModal}
												showPayVeil={showPayVeil}
												showPayModalFunc={showPayModalFunc}
												showPayVeilFunc={showPayVeilFunc}
												hidePayVeilFunc={hidePayVeilFunc}
												total_amount={total_amount}
												mobileViewToggle={mobileViewToggle}
												currentAccount={this.props.currentAccount}

											/>
											
											<button id="orbipay-checkout-button" style={{display:"none"}}></button>
											 {(this.state.showOverlay) &&
											 	<div id="overlay_modal" >
												{this.state.isLoading && <TransactionLoader />}
												{this.state.errorResponse.code.length===0 && <Transaction pcgx={this.props.pcgx} transInfo={this.state.successResponse} onClickHandler={this.paymentConfirmation.bind(this)}/>}
												{this.state.errorResponse.code.length!==0 && <Transaction pcgx={this.props.pcgx} transInfo={this.state.errorResponse} onClickHandler={this.paymentConfirmation.bind(this)}/>}
											</div>}
											 

											<div className="billing-accounts-buttons">
												<button className="primary" onClick={()=>this.handlePaymentRouting(total_amount,accounts)} disabled={disabledToggle}>
													Next
												</button>
											</div>

										</div>
									</div>

							}

							</div>
						</div>
						</main>
					<div className="footer-AccountsPage">
						<FooterAccountsPage />
					</div>

					</div>
					
				</div>
			  <TermsOfUseFooter/>
			  {window.innerWidth<760 && <div className="infoBox support-info-is-hidden">
					<SupportInfo mobile={true}/>
					</div>}
			</div>
		);
	}
}

AccountsPage.propTypes = {
	showPay: bool,
	error: bool,
	message: string,
	submitHandler: func,
	accounts: object,
	openPayModalFunc: func,
	showModal: bool,
	showPayModalFunc: func,
	showPayVeil: bool,
	showPayVeilFunc: func,
	hidePayVeilFunc: func,
	total_amount: number,
}



// WEBPACK FOOTER //
// ./src/components/atomic/pages/AccountsPage/AccountsPage.js